import { combineReducers } from 'redux';
import { FeedbackAction, FeedbackActionType } from '../../actions/feedbackActions';

const loading = (state = false, action: FeedbackAction) => {
  switch (action.type) {
    case FeedbackActionType.SEND_FEEDBACK:
      return true;
    case FeedbackActionType.SEND_FEEDBACK_OK:
    case FeedbackActionType.SEND_FEEDBACK_ERROR:
      return false;
    default:
      return state;
  }
};

const error = (state = '', action: FeedbackAction) => {
  switch (action.type) {
    case FeedbackActionType.SEND_FEEDBACK:
      return '';
    case FeedbackActionType.SEND_FEEDBACK_ERROR:
      return action.error;
    default:
      return state;
  }
};

export default combineReducers({ loading, error });
